import TypeSolutionRequests from '../../server/typeSolution';
import { addLoading, removeLoading } from './loading';

export const getAllTypeSolution = (
  limit,
  skip,
  search,
  orderBy = 'DESC',
  field = 'createdAt',
  loading = true,
) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await TypeSolutionRequests.getAllTypeSolution(limit, skip, search, orderBy, field);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const getTypeSolutionOptions = (search, loading = true) => async (dispatch) => {
  if (loading) dispatch(addLoading());
  try {
    return await TypeSolutionRequests.getTypeSolutionOptions(search);
  } finally {
    if (loading) dispatch(removeLoading());
  }
};

export const createTypeSolution = newTypeSolution => async (dispatch) => {
  dispatch(addLoading());
  try {
    await TypeSolutionRequests.createTypeSolution(newTypeSolution);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateTypeSolution = updTypeSolution => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await TypeSolutionRequests.updateTypeSolution(updTypeSolution);
  } finally {
    dispatch(removeLoading());
  }
};
